import { set } from 'lodash';

import { arrayMove } from 'react-sortable-hoc';

import {
  LOAD_START,
  LOAD_SUCCESS,
  LOAD_FAILURE,
  SAVE_START,
  SAVE_SUCCESS,
  SAVE_FAILURE,
  ADD_TOUR_STEP,
  REMOVE_TOUR_STEP,
  ADD_CATEGORY,
  REMOVE_CATEGORY,
  UPDATE_VALUE,
  SORT_TOUR_STEPS
} from './actions';

const initialState = {
  loading: false,
  saving: false,
  categories: {},
  tour_steps: {},
  terms: {},
  updated: null
  //asJson: null
};

export default (state = {}, action) => {
  let newState = Object.assign({}, initialState, state);
  let id;

  switch (action.type) {
    case LOAD_START:
      newState.loading = true;
      break;
    case LOAD_SUCCESS:
      newState = Object.assign({}, newState, {
        loading: false,
        updated: new Date().getTime(),
        ...action.payload
      });
      break;
    case LOAD_FAILURE:
      newState.loading = false;
      break;
    case SAVE_START:
      newState.saving = true;
      break;
    case SAVE_SUCCESS:
      newState = Object.assign({}, newState, {
        saving: false,
        updated: new Date().getTime(),
        ...action.payload
      });
      break;
    case SAVE_FAILURE:
      newState.saving = false;
      break;
    case UPDATE_VALUE:
      newState = set(newState, action.payload.name, action.payload.value);
      newState.updated = new Date().getTime();
      break;
    case ADD_TOUR_STEP:
      id = 'step-' + new Date().getTime();
      const newStep = {
        id: id,
        placement: 'auto'
      };
      if (action.payload) {
        newStep.url = action.payload;
      }
      newState.tour_steps.value[id] = newStep;
      newState.updated = new Date().getTime();
      break;
    case REMOVE_TOUR_STEP:
      let ts = Object.values(newState.tour_steps.value);
      newState.tour_steps.value = {};
      ts.forEach(step => {
        if (step.id === action.payload.id) {
          return;
        }
        newState.tour_steps.value[step.id] = step;
      });

      newState.updated = new Date().getTime();
      break;
    case ADD_CATEGORY:
      id = new Date().getTime();
      const newCat = {
        id: id
      };
      newState.categories[id] = newCat;
      newState.updated = new Date().getTime();
      break;
    case REMOVE_CATEGORY:
      newState.categories[action.payload.id].deleted = true;
      newState.updated = new Date().getTime();
      break;
    case SORT_TOUR_STEPS:
      const { collection, oldIndex, newIndex } = action.payload;
      let values = Object.values(newState.tour_steps.value);
      let steps = {};
      id = null;

      if (collection === 'All') {
        values = arrayMove(values, oldIndex, newIndex);
      } else {
        let unchanged = [];
        let resorted = [];

        for (let i = 0; i < values.length; i++) {
          if (values[i].url === collection) {
            resorted.push(values[i]);
          } else {
            unchanged.push(values[i]);
          }
        }

        resorted = arrayMove(resorted, oldIndex, newIndex);
        values = unchanged.concat(resorted);
      }

      for (let i = 0; i < values.length; i++) {
        id = `step-${i}`;
        values[i].order = i;
        values[i].id = id;
        steps[id] = values[i];
      }

      newState.tour_steps.value = steps;
      newState.updated = new Date().getTime();
      break;
    default:
      // oh well!
      break;
  }

  return newState;
};



// WEBPACK FOOTER //
// ./src/components/app/settings/reducer.js